// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* nav logo */
.nav-logo {
  height: 2.2rem;
  vertical-align: middle;
  margin-inline-end: .8rem;
}

.navbar-brand {
  font-size: 1.5rem;
  color: #ffffff;
}

.navbar {
  --navbar-line-height: calc(var(--navbar-height) - var(--navbar-vertical-padding) * 2);
  position: fixed;
  inset: 0 0 auto;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  height: var(--navbar-height);
  padding: var(--navbar-vertical-padding) var(--navbar-horizontal-padding);
  box-shadow: 0 2px 8px var(--card-shadow);
  line-height: var(--navbar-line-height);
  white-space: nowrap;
  transition: transform 0.3s ease-in-out, background var(--color-transition), box-shadow var(--color-transition);
  backdrop-filter: saturate(150%) blur(12px);
  flex-wrap: nowrap;
}

.navbar-nav {
  justify-content: flex-end !important;
  border:#fff;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 0.5rem .5rem;
}

.nav-link:hover {
  color: var(--text-color);
}

/* Hamburger icon animation */
.navbar-toggler {
  border: none !important;
  background: none !important;
  outline: none !important;
  padding: 0;
  box-shadow: none !important;
}

.navbar-toggler:focus {
  text-decoration: none;
  outline: none !important;
  box-shadow: none !important;
}

.hamburger-icon {
  display: inline-block;
  cursor: pointer;
}

.hamburger-icon .bar1,
.hamburger-icon .bar2,
.hamburger-icon .bar3 {
  width: 25px;
  height: 2px;
  background-color: var(--text-color);
  margin: 6px 0;
  transition: 0.4s;
}

.navbar-toggler.open .bar1 {
  transform: rotate(-45deg) translate(-6px, 5px);
}

.navbar-toggler.open .bar2 {
  opacity: 0;
}

.navbar-toggler.open .bar3 {
  transform: rotate(45deg) translate(-6px, -5px);
}

@media (max-width: 992px) {
  .navbar-collapse {
      position: fixed;
      font-size: 16px;
      top: 60px;
      right: 0;
      padding: 15px;
      width: 90%;
      max-width: 250px;
      transition: transform 0.3s ease, opacity 0.3s ease;
      display: block;
      background: var(--bg-color-navbar);
      transform: translateX(100%);
      opacity: 0;
      height: calc(100vh - 60px); /* Viewport height minus navbar height */
      overflow-y: auto; /* Enable scrolling */
      -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  }

  .navbar-collapse.show {
      transform: translateX(0);
      opacity: 1;
      visibility: visible;
      height: calc(100vh - 60px); /* Viewport height minus navbar height */
  }

  .navbar-collapse.collapsing {
      transition: transform 0.3s ease, opacity 0.3s ease;
      transform: translateX(100%);
      opacity: 1;
      height: calc(100vh - 60px) !important; /* Viewport height minus navbar height */
  }
}

/* CRT Search in Navbar */
.navbar-crt-search .dark-select__control {
  background-color: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(95, 32, 80, 0.8) !important;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.navbar-crt-search .dark-select__control:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.navbar-crt-search .dark-select__control--is-focused {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.2);
}

.navbar-crt-search .dark-select__placeholder {
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px !important;
}

.navbar-crt-search .dark-select__single-value {
  color: white;
  font-size: 16px !important;
}

.navbar-crt-search .dark-select__input-container {
  color: white;
  font-size: 16px !important;
}

.navbar-crt-search .dark-select__menu {
  background-color: #2c3e50;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 100 !important;
}

.navbar-crt-search .dark-select__option {
  color: white;
  background-color: transparent;
}

.navbar-crt-search .dark-select__option:hover {
  background-color: #FF6A83 !important; /* Darker yellow for selected items */
  color: #000 !important;
  cursor: pointer !important;
}

.navbar-crt-search .dark-select__option--is-focused {
  background-color: #ffeb3b !important; /* Yellow highlight */
  color: #000 !important; /* Black text for better contrast on yellow */
  cursor: pointer !important;
}

.navbar-crt-search .dark-select__option--is-selected {
  background-color: #ffc107 !important; /* Darker yellow for selected items */
  color: #000 !important;
  cursor: pointer !important;
}


`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,cAAc;EACd,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qFAAqF;EACrF,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,4BAA4B;EAC5B,wEAAwE;EACxE,wCAAwC;EACxC,sCAAsC;EACtC,mBAAmB;EACnB,8GAA8G;EAE9G,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE;MACI,eAAe;MACf,eAAe;MACf,SAAS;MACT,QAAQ;MACR,aAAa;MACb,UAAU;MACV,gBAAgB;MAChB,kDAAkD;MAClD,cAAc;MACd,kCAAkC;MAClC,2BAA2B;MAC3B,UAAU;MACV,0BAA0B,EAAE,wCAAwC;MACpE,gBAAgB,EAAE,qBAAqB;MACvC,iCAAiC,EAAE,4BAA4B;EACnE;;EAEA;MACI,wBAAwB;MACxB,UAAU;MACV,mBAAmB;MACnB,0BAA0B,EAAE,wCAAwC;EACxE;;EAEA;MACI,kDAAkD;MAClD,2BAA2B;MAC3B,UAAU;MACV,qCAAqC,EAAE,wCAAwC;EACnF;AACF;;AAEA,yBAAyB;AACzB;EACE,0CAA0C;EAC1C,kDAAkD;EAClD,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC,EAAE,qCAAqC;EAC3E,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC,EAAE,qBAAqB;EAC3D,sBAAsB,EAAE,6CAA6C;EACrE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC,EAAE,qCAAqC;EAC3E,sBAAsB;EACtB,0BAA0B;AAC5B","sourcesContent":["/* nav logo */\n.nav-logo {\n  height: 2.2rem;\n  vertical-align: middle;\n  margin-inline-end: .8rem;\n}\n\n.navbar-brand {\n  font-size: 1.5rem;\n  color: #ffffff;\n}\n\n.navbar {\n  --navbar-line-height: calc(var(--navbar-height) - var(--navbar-vertical-padding) * 2);\n  position: fixed;\n  inset: 0 0 auto;\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  height: var(--navbar-height);\n  padding: var(--navbar-vertical-padding) var(--navbar-horizontal-padding);\n  box-shadow: 0 2px 8px var(--card-shadow);\n  line-height: var(--navbar-line-height);\n  white-space: nowrap;\n  transition: transform 0.3s ease-in-out, background var(--color-transition), box-shadow var(--color-transition);\n  -webkit-backdrop-filter: saturate(150%) blur(12px);\n  backdrop-filter: saturate(150%) blur(12px);\n  flex-wrap: nowrap;\n}\n\n.navbar-nav {\n  justify-content: flex-end !important;\n  border:#fff;\n}\n\n.nav-link {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem .5rem;\n}\n\n.nav-link:hover {\n  color: var(--text-color);\n}\n\n/* Hamburger icon animation */\n.navbar-toggler {\n  border: none !important;\n  background: none !important;\n  outline: none !important;\n  padding: 0;\n  box-shadow: none !important;\n}\n\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.hamburger-icon {\n  display: inline-block;\n  cursor: pointer;\n}\n\n.hamburger-icon .bar1,\n.hamburger-icon .bar2,\n.hamburger-icon .bar3 {\n  width: 25px;\n  height: 2px;\n  background-color: var(--text-color);\n  margin: 6px 0;\n  transition: 0.4s;\n}\n\n.navbar-toggler.open .bar1 {\n  transform: rotate(-45deg) translate(-6px, 5px);\n}\n\n.navbar-toggler.open .bar2 {\n  opacity: 0;\n}\n\n.navbar-toggler.open .bar3 {\n  transform: rotate(45deg) translate(-6px, -5px);\n}\n\n@media (max-width: 992px) {\n  .navbar-collapse {\n      position: fixed;\n      font-size: 16px;\n      top: 60px;\n      right: 0;\n      padding: 15px;\n      width: 90%;\n      max-width: 250px;\n      transition: transform 0.3s ease, opacity 0.3s ease;\n      display: block;\n      background: var(--bg-color-navbar);\n      transform: translateX(100%);\n      opacity: 0;\n      height: calc(100vh - 60px); /* Viewport height minus navbar height */\n      overflow-y: auto; /* Enable scrolling */\n      -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */\n  }\n\n  .navbar-collapse.show {\n      transform: translateX(0);\n      opacity: 1;\n      visibility: visible;\n      height: calc(100vh - 60px); /* Viewport height minus navbar height */\n  }\n\n  .navbar-collapse.collapsing {\n      transition: transform 0.3s ease, opacity 0.3s ease;\n      transform: translateX(100%);\n      opacity: 1;\n      height: calc(100vh - 60px) !important; /* Viewport height minus navbar height */\n  }\n}\n\n/* CRT Search in Navbar */\n.navbar-crt-search .dark-select__control {\n  background-color: rgba(255, 255, 255, 0.1);\n  border: 2px solid rgba(95, 32, 80, 0.8) !important;\n  border-radius: 5px;\n  transition: all 0.3s ease;\n}\n\n.navbar-crt-search .dark-select__control:hover {\n  background-color: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.navbar-crt-search .dark-select__control--is-focused {\n  background-color: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.4);\n  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.2);\n}\n\n.navbar-crt-search .dark-select__placeholder {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 16px !important;\n}\n\n.navbar-crt-search .dark-select__single-value {\n  color: white;\n  font-size: 16px !important;\n}\n\n.navbar-crt-search .dark-select__input-container {\n  color: white;\n  font-size: 16px !important;\n}\n\n.navbar-crt-search .dark-select__menu {\n  background-color: #2c3e50;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  z-index: 100 !important;\n}\n\n.navbar-crt-search .dark-select__option {\n  color: white;\n  background-color: transparent;\n}\n\n.navbar-crt-search .dark-select__option:hover {\n  background-color: #FF6A83 !important; /* Darker yellow for selected items */\n  color: #000 !important;\n  cursor: pointer !important;\n}\n\n.navbar-crt-search .dark-select__option--is-focused {\n  background-color: #ffeb3b !important; /* Yellow highlight */\n  color: #000 !important; /* Black text for better contrast on yellow */\n  cursor: pointer !important;\n}\n\n.navbar-crt-search .dark-select__option--is-selected {\n  background-color: #ffc107 !important; /* Darker yellow for selected items */\n  color: #000 !important;\n  cursor: pointer !important;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
